const origin = 'http://47.243.244.75:8899/public/';
module.exports = {
    // deepBoneDomin : 'https://www.deepbone.cn/'
    apiKey:'Dde-Ananlytics-Utlog-Api-Key',
    deepBoneDomin:'',
    ossImage:'?x-oss-process=image/resize,w_100',
    // logmapUrl:'https://deep-time.org/ddeAnalytics/utlog',
    logmapUrl:'https://log-analysis.deep-time.org/ddeAnalytics/utlog',
    apiKeyUrl:'http://log-analysis.deep-time.org/ddeAnalytics/utlog/authToken'
}
